<template>
  <div>
    <label>
      {{ index }}.
      {{ question }}
    </label>
    <section class="mx-3">
      <p v-if="!responses||responses.length==0" class="text-muted small">
        <i class="material-icons align-middle small">
          error_outline
        </i>
        No answer
      </p>
      <div v-for="item in responses" :key="item.id">
        <p v-if="item&&item.option_text">
          <i class="material-icons align-middle small text-main">
            check_box
          </i>
          {{ item.option_text }}
        </p>
        <p v-if="item.answer_text_1" class="mx-3 my-1">
          {{ item.answer_text_1 }}
        </p>
      </div>
      <b-link v-if="onModal" class="d-flex text-left pt-2" :href="('/skill-planning/'+getSkillName.id)" >
        Go to the plan to edit your answer
      </b-link>
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    responses: Array,
    question: String,
    index: Number,
    id: Number,
    onModal: {
      type:Boolean,
      default:false
    }
  },
  computed: {
    ...mapGetters("planning", [
      "getSkillName",
    ]),
  },
};
</script>
